export default __webpack_public_path__ + "static/media/logo.6331e3ec.png";